import { render, staticRenderFns } from "./imageGalleryBlock.vue?vue&type=template&id=506781b0&scoped=true"
import script from "./imageGalleryBlock.vue?vue&type=script&lang=js"
export * from "./imageGalleryBlock.vue?vue&type=script&lang=js"
import style0 from "./imageGalleryBlock.vue?vue&type=style&index=0&id=506781b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506781b0",
  null
  
)

export default component.exports